module.exports = __webpack_public_path__ + "img/mission-forward-02.jpg?4c0b750b841898be49fe64aa7f2a4911";